import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import { request } from "../../../helpers/httpInterceptor";
import MaterialModal from "../MaterialModal";
import BouncingDots from "../../loading/BouncingDots";
import withModal from "../withModal";
import h from "../../../helpers";

interface IRequestAccessModal {
    isOpen: boolean;
    modalProps: {
        destinationName: string;
    };
}

const DestinationAccessRequestModal: React.FC<IRequestAccessModal> = ({ isOpen, modalProps }: IRequestAccessModal) => {
    const dispatch = useDispatch();
    const [isSending, setIsSending] = useState(false);
    const [requestSent, setRequestSent] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [responseError, setResponseError] = useState(false);

    useEffect(() => {
        setIsSending(false);
        setRequestSent(false);
        setResponseMessage("");
        setResponseError(false);
    }, [isOpen, modalProps]);

    const hide = () => dispatch(hideModal("REQUEST_DESTINATION_ACCESS"));

    const requestAccess = () => {
        setIsSending(true);
        request(
            "/ClientAccess/SendDestinationAccessRequestEmail",
            {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: modalProps.destinationName }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    setResponseMessage(
                        "Your response has been sent to your Relationship Manager. Please continue to select Destinations you currently have access to."
                    );
                } else {
                    setResponseMessage("There was a problem sending the Access Request, please try again later.");
                }
                setIsSending(false);
                setRequestSent(true);
                setResponseError(!data.success);
            })
            .catch(error => {
                h.error("Error sending destination access email.", error);
                setResponseMessage("There was a problem sending the Access Request, please try again later.");
                setIsSending(false);
                setRequestSent(true);
                setResponseError(true);
            });
    };

    return (
        <MaterialModal
            title="Request Access"
            isOpen={isOpen}
            cancelButtonText={requestSent ? "Close" : "Cancel"}
            onClose={() => hide()}
            id="request-access"
            maxWidth="lg"
            primaryButtonText="Request Access"
            onPrimaryButtonRequest={() => requestAccess()}
            isPrimaryButtonDisabled={requestSent}
        >
            <div style={{ width: "650px", fontSize: "18px", marginBottom: "10px" }}>
                {isSending && (
                    <div className="disabled-overlay" style={{ textAlign: "center", paddingTop: "100px" }}>
                        <BouncingDots />
                    </div>
                )}
                {requestSent ? (
                    <div style={{ color: responseError ? "red" : "" }}>{responseMessage}</div>
                ) : (
                    <div>
                        <span style={{ fontSize: "16px" }}>
                            You are about to request access to <strong>{modalProps.destinationName}</strong>. If you
                            would like to proceed, select Request Access and Experian will contact you shortly.
                        </span>
                    </div>
                )}
            </div>
        </MaterialModal>
    );
};

export default withModal(DestinationAccessRequestModal, "REQUEST_DESTINATION_ACCESS");
